import { loadStripe } from '@stripe/stripe-js'
import { SupabaseFunctionsService } from './supabaseFunctionsService'

const stripePromise = loadStripe(import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY)

export class StripeService {
  /**
   * Create a payment intent using Supabase function
   */
  static async createPaymentIntent(amount, currency = 'usd', metadata = {}) {
    try {
      const result = await SupabaseFunctionsService.createPaymentIntent({
        amount,
        currency,
        ...metadata
      })
      return result
    } catch (error) {
      console.error('Create payment intent error:', error)
      return { success: false, error: error.message }
    }
  }


  /**
   * Process payment for an existing registration
   */
  static async processPaymentForRegistration(
    stripe,
    elements,
    registrationData,
    registrationId,
    amount,
    retreatId
  ) {
    try {
      // Step 1: Create payment intent
      const paymentIntentResult = await this.createPaymentIntent(amount, 'usd', {
        retreatId: retreatId.toString(),
        registrationId: registrationId.toString(),
        userEmail: registrationData.email
      })

      if (!paymentIntentResult.success) {
        return { success: false, error: paymentIntentResult.error }
      }

      // Step 2: Confirm payment
      const cardElement = elements.getElement('card')
      const { error, paymentIntent } = await stripe.confirmCardPayment(
        paymentIntentResult.clientSecret,
        {
          payment_method: {
            card: cardElement,
            billing_details: {
              name: `${registrationData.firstName} ${registrationData.lastName}`,
              email: registrationData.email,
              phone: registrationData.phone
            }
          }
        }
      )

      if (error) {
        return { success: false, error: error.message }
      }

      // Step 3: Process payment for the existing registration
      const paymentResult = await SupabaseFunctionsService.processPayment({
        registrationId: registrationId,
        amount: amount,
        currency: 'USD',
        paymentMethodId: paymentIntent.payment_method.id,
        stripePaymentIntentId: paymentIntent.id
      })

      if (!paymentResult.success) {
        return { success: false, error: paymentResult.error }
      }

      return {
        success: true,
        paymentIntent,
        registration: paymentResult.registration,
        user: paymentResult.user,
        payment: paymentResult.payment,
        retreat: paymentResult.retreat
      }
    } catch (error) {
      console.error('Process payment for registration error:', error)
      return { success: false, error: error.message }
    }
  }
}

export default StripeService
